function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBlueArrow = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 212.46 220.69",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 212.46,
    height: 220.69,
    rx: 106.23,
    ry: 106.23,
    style: {
      fill: "#5086a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.64,186.7l74.13-74.13c1.18-1.18,1.18-3.27,0-4.45L81.64,33.99c-.59-.59-1.39-.92-2.23-.92s-1.63.33-2.22.92l-20.45,20.45c-.62.61-.92,1.41-.92,2.22s.31,1.62.92,2.23l51.45,51.45-51.45,51.45c-1.18,1.18-1.18,3.28,0,4.46l20.45,20.44c1.23,1.23,3.22,1.23,4.45,0h0Z",
    style: {
      fill: "#fff"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlueArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/blue_arrow.87c6f9ee.svg";
export { ForwardRef as ReactComponent };